import LoanTotals from './loan-totals';

export default LoanTotals;
